import { render, staticRenderFns } from "./faxHistory.vue?vue&type=template&id=74aed770&scoped=true"
import script from "./faxHistory.vue?vue&type=script&lang=js"
export * from "./faxHistory.vue?vue&type=script&lang=js"
import style0 from "./faxHistory.vue?vue&type=style&index=0&id=74aed770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74aed770",
  null
  
)

export default component.exports